import React from 'react';
import {Link} from 'react-router-dom';
import {Button} from "../../../components/Button";
import Title from "../../../components/Title";
import {bindActionCreators} from "redux";
import {fetchCurrentUser, updateCurrentUser} from "../../../../creators/currentUser";
import connect from "react-redux/es/connect/connect";
import {PageLoader} from "../../../components/Loader";
import {CheckboxInputField} from "../../../components/FormField";
import MkEditor from "../../../components/editor/Editor";
import {config} from "../../../../config";
import Helmet from "react-helmet";

class SettingsSignature extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            contentRaw: {},
            // bbcode : this.props.currentUser.setting.signature.bbcode,
            display: false,
        };
        this.handleSubmitMessageTimeout = this.handleSubmitMessageTimeout.bind(this);
    }

    componentDidMount(oldProps) {
        this.props.fetchCurrentUser();
        const newProps = this.props;
        if ((oldProps && oldProps.currentUserInitialized !== newProps.currentUserInitialized) || newProps.currentUserInitialized === true) {
            let currentUser = newProps.currentUser;
            this.setState({
                contentRaw: currentUser.setting.signature.contentRaw || [],
                display: currentUser.setting.signature.display
            });
        }
        // if(!Array.isArray(this.props.currentUser.profile.signature.content)){
        //   replaceBbcode(this.props.currentUser.profile.signature.content).then(signature=>this.setState({signature, bbcode : this.props.currentUser.profile.signature.bbcode}));
        // }
        // else{
        //   this.setState({signature: this.props.currentUser.profile.signature.content, bbcode : this.props.currentUser.profile.signature.content});
        // }
    }

    componentDidUpdate(prevProps){
        if(prevProps.currentUser.setting.signature.contentRaw !== this.props.currentUser.setting.signature.contentRaw){
            this.setState({contentRaw: this.props.currentUser.setting.signature.contentRaw});
        }
    }

    handleSubmit(event){
        event.preventDefault();
        event.stopPropagation();
        setTimeout(()=>{
            this.handleSubmitMessageTimeout();
        },50)
    }

    handleSubmitMessageTimeout() {
        let currentUser = {
            setting: {
                signature: {
                    contentRaw: this.state.contentRaw,
                    display: this.state.display
                }
            }
        };

        if (!this.props.currentUserLoading) {
            this.props.updateCurrentUser(currentUser);
        }
    }

    render() {
        return !this.props.currentUserInitialized ? <PageLoader/> : (
            <div className="settings-wrapper">
                <Helmet>
                    <title>{config.preTitle}Paramètre de signature{config.postTitle}</title>
                </Helmet>
                <div className="block">
                    <form onSubmit={(e) => this.handleSubmit(e)} className="content">
                        <Title className={"settings-title"} heading={"heading-2"} display={"display-2"}>Modifier votre
                            signature</Title>
                        <span className="edit-span mb-16">Votre signature doit respecter la <Link
                            to="//www.voissa.com/charte/">charte Voissa</Link>, ne pas être trop encombrante pour ne pas gêner les autres utilisateurs. Les liens commerciaux sont interdits.</span>

                        <MkEditor kind={"userContent"} onChange={(contentRaw) => this.setState({contentRaw})}
                                  defaultValue={this.props.currentUser.setting.signature.contentRaw}/>

                        <CheckboxInputField checked={this.state.display}
                                            onChange={() => this.setState({display: !this.state.display})}
                                            htmlFor="display"
                                            id="display"
                                            className={"my-8"}
                                            label={"Attacher la signature par défaut"}/>
                        <div className="settings-btn-group">
                            <Button size={"medium"}
                                    btnType={"submit"}
                                    loading={this.props.currentUserSubmitting}
                                    btnStyle={"primary-reverse"}
                                    content={"Enregistrer"}/>
                        </div>
                    </form>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        currentUser: state.currentUser.data,
        currentUserLoading: state.currentUser.loading,
        currentUserSubmitting: state.currentUser.submitting,
        currentUserInitialized: state.currentUser.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchCurrentUser,
    updateCurrentUser
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SettingsSignature);
